(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('soggetto-esterno', {
            parent: 'entity',
            url: '/soggetto-esterno?legislatura',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.soggettoEsterno.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esternos.html',
                    controller: 'SoggettoEsternoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('soggettoEsterno');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('soggetto-esterno-detail', {
            parent: 'soggetto-esterno',
            url: '/soggetto-esterno/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.soggettoEsterno.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esterno-detail.html',
                    controller: 'SoggettoEsternoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('soggettoEsterno');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SoggettoEsterno', function($stateParams, SoggettoEsterno) {
                    return SoggettoEsterno.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'soggetto-esterno',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }],
                legislature: ['Atto', function(Atto) {
                    return Atto.queryLegislature().$promise;
                }]
            }
        })
        .state('soggetto-esterno-detail.edit', {
            parent: 'soggetto-esterno-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esterno-dialog.html',
                    controller: 'SoggettoEsternoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SoggettoEsterno', function(SoggettoEsterno) {
                            return SoggettoEsterno.get({id : $stateParams.id}).$promise;
                        }],
                        legislature: ['Atto', function(Atto) {
                            return Atto.queryLegislature().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('soggetto-esterno.new', {
            parent: 'soggetto-esterno',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esterno-dialog.html',
                    controller: 'SoggettoEsternoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        },
                        legislature: ['Atto', function(Atto) {
                            return Atto.queryLegislature().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('soggetto-esterno', null, { reload: 'soggetto-esterno' });
                }, function() {
                    $state.go('soggetto-esterno');
                });
            }]
        })
        .state('soggetto-esterno.edit', {
            parent: 'soggetto-esterno',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esterno-dialog.html',
                    controller: 'SoggettoEsternoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SoggettoEsterno', function(SoggettoEsterno) {
                            return SoggettoEsterno.get({id : $stateParams.id}).$promise;
                        }],
                        legislature: ['Atto', function(Atto) {
                            return Atto.queryLegislature().$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('soggetto-esterno', null, { reload: 'soggetto-esterno' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('soggetto-esterno.delete', {
            parent: 'soggetto-esterno',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/soggetto-esterno/soggetto-esterno-delete-dialog.html',
                    controller: 'SoggettoEsternoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SoggettoEsterno', function(SoggettoEsterno) {
                            return SoggettoEsterno.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('soggetto-esterno', null, { reload: 'soggetto-esterno' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
